import { StyleSheet } from 'react-native';
import { brand } from 'src/theme/colors';
import { DISCOUNT_MILESTONE_OFFSETS } from './DiscountMilestone.constants';

export const styles = StyleSheet.create({
  milestoneWrapper: {
    position: 'absolute',
    transform: [
      { translateX: -DISCOUNT_MILESTONE_OFFSETS.desktop.x },
      { translateY: DISCOUNT_MILESTONE_OFFSETS.desktop.y },
    ],
    justifyContent: 'center',
    alignItems: 'center',
  },

  milestoneWrapperMobile: {
    position: 'absolute',
    transform: [
      { translateX: -DISCOUNT_MILESTONE_OFFSETS.mobile.x },
      { translateY: DISCOUNT_MILESTONE_OFFSETS.mobile.y },
    ],
    justifyContent: 'center',
    alignItems: 'center',
  },

  milestone: {
    width: 26,
    height: 26,
    borderRadius: 13,
    justifyContent: 'center',
    alignItems: 'center',
  },

  textNotActive: {
    fontSize: 11,
    fontWeight: 700,
    lineHeight: 12,
  },

  textPercentage: {
    fontSize: 8,
    fontWeight: 700,
    lineHeight: 9,
  },

  checkIcon: {
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
  },

  photos: {
    marginTop: 4,
    fontSize: 9,
    fontWeight: 700,
    lineHeight: 10,
    color: brand.main.orange,
    minWidth: 35,
  },
});
